import React from "react";

import Actions from "./Actions";

const columns = [
  {
    name: "File Name",
    selector: "attributes.title",
    sortable: true,
  },
  {
    name: "File",
    selector: "attributes.file_name",
    sortable: true,
    cell: (row) => (
      <a class="green" href={row.attributes.file_url} target="_blank">
        {row.attributes.file_name}
      </a>
    ),
  },
  {
    name: "Actions",
    sortable: false,
    width: "100px",
    cell: (row) => <Actions row={row} />,
  },
];

export default columns;
